import { Link as RouterLink } from "react-router-dom";
import { Box } from "@mui/material";
import BlogCover from "./BlogCover";

const BlogPostCard = ({ post, variant = "grid", priority = false }) => {
  const isFeatured = variant === "featured";
  const isRelated = variant === "related";

  return (
    <Box
      component={RouterLink}
      to={`/blog/${post.slug}`}
      sx={{
        display: "block",
        borderRadius: 3,
        overflow: "hidden",
        border: "1px solid",
        borderColor: "rgba(94,53,177,0.12)",
        boxShadow: "0 8px 24px rgba(94,53,177,0.08)",
        textDecoration: "none",
        color: "inherit",
        transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
        "&:hover": {
          borderColor: "primary.main",
          transform: "translateY(-3px)",
          boxShadow: "0 16px 36px rgba(94,53,177,0.14)",
        },
      }}
    >
      <BlogCover
        post={post}
        size={isFeatured ? "featured" : isRelated ? "thumb" : "card"}
        priority={priority}
        titleComponent={isFeatured ? "h2" : "h3"}
      />
    </Box>
  );
};

export default BlogPostCard;
